export const GET_QUESTIONS_SECRETS: '@credentials/GET_QUESTIONS_SECRETS' =
  '@credentials/GET_QUESTIONS_SECRETS';
export const SET_QUESTIONS_SECRETS: '@credentials/SET_QUESTIONS_SECRETS' =
  '@credentials/SET_QUESTIONS_SECRETS';
export const SET_PASSWORD_RECOVERY_STEP: '@credentials/SET_PASSWORD_RECOVERY_STEP' =
  '@credentials/SET_PASSWORD_RECOVERY_STEP';
export const SUBMIT_PASSWORD_RECOVERY_STEP: '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP' =
  '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP';
export const SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS: '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS' =
  '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS';
export const SUBMIT_PASSWORD_RECOVERY_STEP_FAIL: '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP_FAIL' =
  '@credentials/SUBMIT_PASSWORD_RECOVERY_STEP_FAIL';
export const PREVIOUS_PASSWORD_RECOVERY_STEP: '@credentials/PREVIOUS_PASSWORD_RECOVERY_STEP' =
  '@credentials/PREVIOUS_PASSWORD_RECOVERY_STEP';
export const SET_LOGIN_RECOVERY_STEP: '@credentials/SET_LOGIN_RECOVERY_STEP' =
  '@credentials/SET_LOGIN_RECOVERY_STEP';
export const SUBMIT_LOGIN_RECOVERY_STEP: '@credentials/SUBMIT_LOGIN_RECOVERY_STEP' =
  '@credentials/SUBMIT_LOGIN_RECOVERY_STEP';
export const SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS: '@credentials/SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS' =
  '@credentials/SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS';
export const SUBMIT_LOGIN_RECOVERY_STEP_FAIL: '@credentials/SUBMIT_LOGIN_RECOVERY_STEP_FAIL' =
  '@credentials/SUBMIT_LOGIN_RECOVERY_STEP_FAIL';
export const PREVIOUS_LOGIN_RECOVERY_STEP: '@credentials/PREVIOUS_LOGIN_RECOVERY_STEP' =
  '@credentials/PREVIOUS_LOGIN_RECOVERY_STEP';
export const SET_TOKEN_CREDENTIALS: '@credentials/SET_TOKEN_CREDENTIALS' =
  '@credentials/SET_TOKEN_CREDENTIALS';

export const CHANGE_PASSWORD: '@credentials/CHANGE_PASSWORD' =
  '@credentials/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS: '@credentials/CHANGE_PASSWORD_SUCCESS' =
  '@credentials/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL: '@credentials/CHANGE_PASSWORD_FAIL' =
  '@credentials/CHANGE_PASSWORD_FAIL';

export const CHANGE_SECRET_QUESTION: '@credentials/CHANGE_SECRET_QUESTION' =
  '@credentials/CHANGE_SECRET_QUESTION';
export const CHANGE_SECRET_QUESTION_SUCCESS: '@credentials/CHANGE_SECRET_QUESTION_SUCCESS' =
  '@credentials/CHANGE_SECRET_QUESTION_SUCCESS';
export const CHANGE_SECRET_QUESTION_FAIL: '@credentials/CHANGE_SECRET_QUESTION_FAIL' =
  '@credentials/CHANGE_SECRET_QUESTION_FAIL';

export const ENABLE_NOTIFICATIONS: '@credentials/ENABLE_NOTIFICATIONS' =
  '@credentials/ENABLE_NOTIFICATIONS';
export const ENABLE_NOTIFICATIONS_SUCCESS: '@credentials/ENABLE_NOTIFICATIONS_SUCCESS' =
  '@credentials/ENABLE_NOTIFICATIONS_SUCCESS';
export const ENABLE_NOTIFICATIONS_FAIL: '@credentials/ENABLE_NOTIFICATIONS_FAIL' =
  '@credentials/ENABLE_NOTIFICATIONS_FAIL';
export const FORGOT_PASSWORD_BY_EMAIL: '@credentials/FORGOT_PASSWORD_BY_EMAIL' =
  '@credentials/FORGOT_PASSWORD_BY_EMAIL';
